import { Typography, GridLegacy as Grid } from '@mui/material';
import LoadingPage from 'components/ui/LoadingPage';
import React from 'react';

import { useRouter } from '../../hooks/useRouter';
import {
  PropertyWithRelations,
  useGetPropertiesQuery,
} from '../../redux/ellipsisApi';

import ListingCard from './ListingCard';

interface OwnProps {
  limit?: string;
  location?: string;
}

const PropertyList: React.FC<OwnProps> = (props) => {
  const { limit } = props;
  const propertyLimit = limit ?? '100';
  const router = useRouter();
  const { data: allProperties, isLoading: allPropertiesIsLoading } =
    useGetPropertiesQuery({
      limit: propertyLimit,
    });

  return (
    <>
      <Grid item xs={12} mt={4} mb={4}>
        <Typography variant="h1" align="left">
          All properties
        </Typography>
      </Grid>
      <Grid container spacing={4}>
        {allProperties &&
          allProperties?.map((property: PropertyWithRelations, key: number) => (
            <Grid item xs={12} sm={6} md={4} key={key}>
              <ListingCard
                bookable={property}
                bookableType={'Property'}
                router={router}
              />
            </Grid>
          ))}
      </Grid>
      {allPropertiesIsLoading && <LoadingPage background="white" />}
    </>
  );
};

export default PropertyList;
